export enum SelectedTabEnum {
    TERMS = 'terms',
    SHIPPING = 'shipping',
    PRIVACY = 'privacy'
}